// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"241":"d14fed89c8d3c652","2024":"bb6c434768d3014f","9658":"e4fba2fd96197188"}[chunkId] + ".css";
};